<div class="tp-dialog tp-confirm" role="alertdialog" aria-labelledby="tp-confirm-title">
  <div class="tp-dialog__head">
    <span class="tp-dialog__icon" [class.tp-dialog__icon--warning]="data.tone === 'warning'" [class.tp-dialog__icon--danger]="data.tone === 'danger'" aria-hidden="true">
      <mat-icon>{{ data.icon ?? 'done_all' }}</mat-icon>
    </span>
    <div class="tp-dialog__titles">
      <h2 class="tp-dialog__title" id="tp-confirm-title">{{ data.title }}</h2>
      @for (line of data.lines; track $index) {
        <p class="tp-dialog__sub">{{ line }}</p>
      }
    </div>
  </div>
  <div class="tp-dialog__footer">
    <button type="button" class="tp-btn tp-btn--ghost" (click)="cancel()">{{ data.cancelLabel ?? 'Cancelar' }}</button>
    <button type="button" class="tp-btn" [class.tp-btn--primary]="data.tone !== 'danger'" [class.tp-btn--danger]="data.tone === 'danger'" (click)="confirm()">
      {{ data.confirmLabel }}
    </button>
  </div>
</div>
